module.exports = __webpack_public_path__ + "static/media/ClearDarkSky.e213e1ec.png";